import { render } from "./RemateFeaturedComponent.vue?vue&type=template&id=7646c888"
import script from "./RemateFeaturedComponent.vue?vue&type=script&lang=js"
export * from "./RemateFeaturedComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src69468266/src/ln-campo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__